import { createContext, useMemo, useReducer } from "react"
import { produce } from "immer"
import { usePreferences } from "hooks/use-preferences"

const PREFERENCE_SUBTYPE = "factors-view-performance"
const PREFERENCE_FIELDS = [
  "selectedMetricDisplay",
]

const DEFAULT_STATE = {
  selectedMetricDisplay: "cumulativePercent",
}

export const PERFORMANCE_CONTEXT = createContext()

function reducer(current, action) {
  return produce(current, draft => {
    switch (action.type) {
      case "setSelectedMetricDisplay":
        draft.selectedMetricDisplay = action.selectedMetricDisplay
        break
      case "setPreferences":
        if (action.preferences) {
          Object.assign(draft, action.preferences)
        }
        break
    }
  })
}

function setPreferences(preferences) {
  return { type: "setPreferences", preferences }
}

export default function ContentSetContext({ children }) {
  const [state, dispatch] = useReducer(reducer, DEFAULT_STATE)

  const isPreferencesLoaded = usePreferences(
    PREFERENCE_SUBTYPE,
    PREFERENCE_FIELDS,
    state,
    dispatch,
    setPreferences,
  )

  const contextUpdaters = useMemo(() => ({
    setSelectedMetricDisplay: (selectedMetricDisplay) => dispatch({ type: "setSelectedMetricDisplay", selectedMetricDisplay }),
  }), [dispatch])

  const contextValue = useMemo(() => ({
    ...state,
    ...contextUpdaters,
    isPreferencesLoaded,
  }), [state, contextUpdaters, isPreferencesLoaded])

  return <PERFORMANCE_CONTEXT.Provider value={contextValue}>
    {children}
  </PERFORMANCE_CONTEXT.Provider>
}
